<template>
    <div class="position-box primaryCertification">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
        </div>
        <div class="cotainer">
            <h1 class="h1">{{$t('my.pc')}}</h1>
            <!-- <h3 class="h3">请确认是您本人的身份证,验证完不可修改</h3> -->
            <div class="country-box" @click="goCountry"><div>{{$t('level1.gjlb')}}</div><input class="input" v-model="country" type="text" readonly :placeholder="$t('level1.qxzgjlb')"><img class="arrow" v-if="theme" src="@/assets/theme/jiantou.png" alt=""><img class="arrow" v-else src="@/assets/arrow_right.png" alt=""></div>
            <div class="tips">{{$t('level1.zjlx')}}</div>
            <div class="input-box" @click.stop="down">
                <input class="input" v-model="id_card_name" type="text" readonly :placeholder="$t('level1.qxzzjlx')" autocomplete="off">
                <img class="down" src="@/assets/down.png" alt="">
            </div>
            <div class="tips">{{$t('level1.name')}}</div>
            <div class="input-box"><input class="input" v-model="true_name" type="text" :disabled="name_auth_status == 1 || name_auth_status == 2" :placeholder="$t('level1.input-username')" autocomplete="off"></div>
            <div class="tips">{{$t('level1.zjhm')}}</div>
            <div class="input-box"><input class="input" v-model="id_card" type="text" :disabled="name_auth_status == 1 || name_auth_status == 2" :placeholder="$t('level1.input-idcard')" autocomplete="off"></div>
            <button class="btn-login btn-bg" v-if="name_auth_status == 1">{{$t('gjrz.shz')}}</button>
            <button class="btn-login btn-bg" v-else-if="name_auth_status == 2">{{$t('gjrz.shtg')}}</button>
            <button class="btn-login btn-bg" v-else @click="nextStep">{{$t('level1.wc')}}</button>
        </div>
        <div class="mask" v-show="isSelect" @click="down"></div>
        <ul class="card-box" v-show="isSelect">
          <li class="card" v-for="(item,index) in idCardArr" :key="index" @click.stop="select(item.id,item.name)">{{item.name}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'primaryCertification',
    data () {
        return {
          lang: 'en',
          theme: false,
          isSelect: false,
          token: '',
          country: '',
          true_name: '',
          id_card: '',
          id_card_type: '',
          id_card_name: '',
          idCardArr: '',
          name_auth_status: '',
          count: 1
        }
    },
    created(){
      this.lang = localStorage.getItem('language') || 'en';
      this.country = localStorage.getItem('country') || '';
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.country = localStorage.getItem('country') || country[0][this.lang];
    },
    mounted() {
        this.getCenterLevel();
        this.getIdcardType()
    },
    methods: {
       goBack(){
           this.$router.push('/user')
       },
       getCenterLevel(){
            let that = this;
            let params = {
                level:1
            }
            this.$ajax.get('/web/getCenterLevel',{params}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  // this.$toast.center(res.data.message);
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                this.true_name = resData.name;
                this.id_card = resData.id_card;
                this.id_card_name = resData.card_type_name;
                this.name_auth_status = resData.name_auth_status;
                if(resData.name_auth_status == 1 || resData.name_auth_status == 2){
                  this.country = resData.country
                }else{
                  this.country = this.country
                }
            }).catch(function(err){
                console.log(err)
            })
        },
       getIdcardType(){
            this.$ajax.get('/web/getIdcardType',{}).then((res) => {
                let resData = res.data.data;
                this.idCardArr = resData;
                if(!this.id_card_type){
                    this.id_card_name = resData[0].name;
                    this.id_card_type = resData[0].id;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       down(){
         if(this.name_auth_status == 1 || this.name_auth_status == 2) return;
         this.isSelect = !this.isSelect;
       },
       select(id,name){
           this.id_card_type = id;
           this.id_card_name = name;
           this.isSelect = false
       },
       nextStep(){
            if(!this.country){
                this.$toast.center(this.$t('level1.qxzgjlb'));
                return false;
            }
            if(!this.id_card_name || this.id_card_name == null){
                this.$toast.center(this.$t('level1.qxzzjlx'));
                return false;
            }
           if(!this.true_name){
                this.$toast.center(this.$t('level1.input-username'));
                return false;
            }
            if(!this.id_card || this.id_card == null){
                this.$toast.center(this.$t('level1.input-idcard'));
                return false;
            }
            let params = {
                true_name: this.true_name,
                id_card: this.id_card,
                country: this.country,
                id_card_type: this.id_card_type
            }
            if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
            this.$ajax.post('/web/setNameAuth',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  this.$toast.center(resData.message);
                  setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/user')
                  }, 1000)
              }else{
                  this.count = 1;
                  this.$toast.center(resData.message);
                  return;
              }
            }).catch(function(err){
                console.log(err)
            })
       },
       goCountry(){
        if(this.name_auth_status == 1 || this.name_auth_status == 2) return;
        this.$router.push('/city')
       }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 1.6rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .h1{
        padding: .28rem 0 .3rem;
        color: #000;
        font-size: .78rem;
    }
    .cotainer .h3{
        color: #de3636;
        font-size: .4rem;
    }
    .cotainer .tips{
        padding: .54rem 0 .26rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .country-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .64rem;
        padding: .48rem 0;
        border-bottom: 1px solid #ececec;
    }
    .cotainer .country-box .arrow{
        width: .22rem;
    }
    .cotainer .input-box{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .32rem 0;
        border-bottom: .01rem solid #ececec;
    }
    .cotainer .input-box .down{
        width: .6rem;
    }
    .cotainer .input-pwd{
        margin-top: .76rem;
    }
    .card-box{
        position: absolute;
        left: -1px;
        right: 0;
        bottom: 0;
        z-index: 1000;
        /* border: 1px solid #b3b3b3; */
        background: #fff;
        border-radius: .08rem;
    }
    .card-box .card{
        height: 1.2rem;
        color: #000;
        font-size: .42rem;
        line-height: 1.2rem;
        border-bottom: 1px solid #b3b3b3;
        text-align: center;
    }
    .card-box .card:last-child{
        border-bottom: none;
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42rem;
    }
    .cotainer .input-box .code{
        color: #588bf8;
        font-size: .48rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
        margin-top: 1.7rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/primaryCertification.vue